'use client';

import { useEffect } from 'react';

import { captureException } from '@/lib/sentry';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
  /** Prefer over `reset` — re-fetches and re-renders the segment (Next.js 16.2). */
  unstable_retry: () => void;
}

export default function Error({ error, reset, unstable_retry }: ErrorProps) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <div className='flex w-full items-center justify-center min-h-screen p-4'>
      <div className='flex flex-col items-center gap-4 max-w-md text-center'>
        <h2 className='text-20 font-bold text-gray-50 dark:text-gray-10'>Something went wrong</h2>
        <p className='text-text-muted-light dark:text-text-muted-dark text-14'>
          An unexpected error occurred. You can try again or navigate elsewhere.
        </p>
        <button
          className='px-4 py-2 rounded-1 bg-yv-red text-white hover:opacity-90'
          onClick={() => (unstable_retry ?? reset)()}
          type='button'
        >
          Try again
        </button>
      </div>
    </div>
  );
}
